<template>
  <div>
    <v-app-bar fixed color="white" elevate-on-scroll class="appbar">
      <v-container>
        <v-row>
          <!-- Logo -->
          <v-col cols="8" md="3" lg="3" xl="2" offset-lg="1" offset-xl="2">
            <div class="justify-center">
              <router-link to="/">
                <v-img
                  class="hidden-md-and-up"
                  src="../assets/logo_HK - Bioland.svg"
                  width="240"
                />
                <v-img
                  class="hidden-sm-and-down mt-1"
                  src="../assets/logo_HK - Bioland.svg"
                  width="240"
                />
              </router-link>
            </div>
          </v-col>

          <!-- Tab-Navigation -->
          <v-col cols="9" lg="7" xl="6" class="hidden-sm-and-down">
            <v-tabs color="green darken-2" optional>
              <v-tab
                v-for="item in menuItems"
                :key="item.text"
                router
                :to="item.route"
                >{{ item.text }}
              </v-tab>
              <v-tab v-if="$store.state.cart.length > 0" router :to="cart.route"
                >{{ cart.text }}
              </v-tab>
            </v-tabs>
          </v-col>

          <!-- Menü-Button -->
          <v-spacer class="hidden-md-and-up" />
          <v-col cols="2" class="hidden-md-and-up text-right">
            <v-app-bar-nav-icon @click="drawer = !drawer" color="greend"
              >Menü</v-app-bar-nav-icon
            >
          </v-col>
        </v-row>
      </v-container>
    </v-app-bar>

    <!-- Navigation-Drawer -->
    <v-navigation-drawer v-model="drawer" fixed temporary right>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title greend--text text-center subtitle-1">
            MENÜ
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list>
        <v-list-item-group active-class="greend--text text-accent-4">
          <v-list-item
            v-for="item in menuItems"
            :key="item.text"
            router
            :to="item.route"
          >
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ item.text }}</v-list-item-title>
            <v-divider></v-divider>
          </v-list-item>

          <v-list-item
            v-if="$store.state.cart.length > 0"
            router
            :to="cart.route"
          >
            <v-list-item-icon>
              <v-icon>{{ cart.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ cart.text }}</v-list-item-title>
            <v-divider></v-divider>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

    <v-container class="hidden-md-and-up" style="height: 56px"> </v-container>
    <v-container class="hidden-sm-and-down" style="height: 64px"> </v-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      drawer: false,
      menuItems: [
        { text: "Start", icon: "mdi-home", route: "/" },
        {
          text: "Unser Betrieb",
          icon: "mdi-tractor-variant",
          route: "/betrieb"
        },
        { text: "Online-Shop", icon: "mdi-leaf", route: "/shop" }
      ],
      cart: { text: "Warenkorb", icon: "mdi-cart", route: "/cart" }
    };
  }
};
</script>

<style scoped>
.v-toolbar__content {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}
.appbar >>> .v-toolbar__content {
  padding: 0 !important;
}

.v-tabs >>> .v-item-group {
  height: 64px;
}
</style>
